import React from 'react';
import './Become.css';
import Speaker from "../../img/Become/speaker.svg";
import Sponsor from "../../img/Become/sponsor.svg";

const Become = (props) => {
    const state = {
        Become_item: [ 
            {
                img: Speaker,
                title: 'Become a speaker',
                href: 'https://forms.gle/R4iaN68Jmw2WZEYc8',
            },
            {
                img: Sponsor,
                title: 'Become a sponsor',
                href: 'https://forms.gle/cHiDL6oBSQiFwsVo9',
                sponsorship: 'https://drive.google.com/file/d/1y0QoueqFDljx0X0u4QnxsKOAKV51232n/view?usp=sharing',
            },
      ],
    };

    const renderBecome_item = (item, i) => {
        return (
            <div className="become_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="" />
                <p className='become_title'>{item.title}</p>
                <a className='become_button' target='_blank' rel="noreferrer" href={item.href}>Apply</a>
                {item.sponsorship && <a className='become_button become_button--sponsorship' target='_blank' rel="noreferrer" href={item.sponsorship}>Prospectus</a>}
            </div>
        );
    };

    return (
        <div className="become" id='become'>
            <div className="container">
                {state.Become_item.map((item, i) => renderBecome_item(item, i))}
            </div>
        </div>
    );
};

export default Become;